import * as types from './types'
import { IPaginatedRequest } from '@cbgms/api/request'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import {
  AdministrationListResponse,
  ErroredSoftwareResponse,
  ExampleBookingReportGETResponse,
  InvoiceExportListItem,
  InvoiceExportListResponse,
  InvoiceExportPOSTBody,
  InvoiceExportPOSTResponse,
  InvoiceExportPUTBody,
  InvoiceExportPUTResponse
} from '@cbgms/api'
import { fields } from '@cbgms/components/list'

export const loadExportedInvoices = (params: IPaginatedRequest = {}) => {
  const requiredColumns = fields<InvoiceExportListItem>()
    .add(o => o.InvoiceExport.AdministrationUUID)
    .add(o => o.InvoiceExport.InvoiceUUID)
    .add(o => o.InvoiceExport.ExportInvoiceType)
    .add(o => o.InvoiceExport.ManualStatus)
    .add(o => o.InvoiceExport.InvoiceType)
    .toString()

  return AsyncAction<InvoiceExportListResponse>({
    type: [types.LOAD_EXPORTED_INVOICES, types.LOAD_EXPORTED_INVOICES_SUCCESS, types.LOAD_EXPORTED_INVOICES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/accountancy/export',
        params: {
          ...params,
          fields: `${params.fields},${requiredColumns}`
        }
      }
    }
  })
}

export const loadErroredList = () =>
  AsyncAction<ErroredSoftwareResponse>({
    type: [types.LOAD_ERRORED_LIST, types.LOAD_ERRORED_LIST_SUCCESS, types.LOAD_ERRORED_LIST_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/accountancy/errored-list'
      }
    }
  })

export const exportInvoices = (data: InvoiceExportPOSTBody) =>
  AsyncAction<InvoiceExportPOSTResponse>({
    type: [types.EXPORT_WORKORDER_INVOICES, types.EXPORT_WORKORDER_INVOICES_SUCCESS, types.EXPORT_WORKORDER_INVOICES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/accountancy/export',
        data
      }
    }
  })

export const loadAdministrations = () =>
  AsyncAction<AdministrationListResponse>({
    type: [types.LOAD_ADMINISTRATIONS, types.LOAD_ADMINISTRATIONS_SUCCESS, types.LOAD_ADMINISTRATIONS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/accountancy/administrations?Fields=Administration.*'
      }
    }
  })

export const updateInvoice = (exportInvoiceType: string, data: InvoiceExportPUTBody) =>
  AsyncAction<InvoiceExportPUTResponse>({
    type: [types.UPDATE_INVOICE_STATUS, types.UPDATE_INVOICE_STATUS_SUCCESS, types.UPDATE_INVOICE_STATUS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/accountancy/update-invoice/${exportInvoiceType}`,
        data
      }
    }
  })

export const getExampleBookingReport = (administrationUUID: string, invoiceType: string, invoiceUUID: string) =>
  AsyncAction<ExampleBookingReportGETResponse>({
    type: [types.LOAD_EXAMPLE_BOOKING, types.LOAD_EXAMPLE_BOOKING_SUCCESS, types.LOAD_EXAMPLE_BOOKING_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/accountancy/example-booking-report/${administrationUUID}/${invoiceType}/${invoiceUUID}`
      }
    }
  })
